import { IFieldAccessType, IOptionValue } from '../../../../../component/admin-module/module/users/interface/field';
import { UploadedFile } from '../../../../api-request/upload';
import ValidateField from '../../../validation';
import { IValidationError } from '../../../validation/type/validation-type';
import { FieldElement } from '../../field-element';
import { TValidationType, PropType } from '../field-properties.handler';

interface IFileProps {
  value: UploadedFile | null;
  fieldType?: 'file';
  error?: IValidationError[];
  filteredOption?: IOptionValue[];
  optionsFilterSearch?: string;
  selectedOptionFilter?: IOptionValue[];
}

export class FileProps extends PropType<IFileProps, IFileProps> {

  processValueFromRef(props: IFileProps): IFileProps {
    props.value = props.value || null;
    props.fieldType = props.fieldType || 'file';
    return props;
  }

  processValueToRef(newProps: IFileProps): IFileProps {
    newProps.value = newProps.value || null;
    return newProps;
  }

  processValidation(props: IFileProps, field: FieldElement, validationType: TValidationType): IValidationError[] {
    const value = props.value || null;
    const validateField = new ValidateField();
    const validate = validateField.singleField(field, value, validationType);
    return field.accessType === IFieldAccessType.Required || !!value ? validate : [];
  }
}